import * as React from 'react';
import { GuestType } from 'models/product';
import { GuestTypeList } from './GuestTypeList';

interface Props {
  guestTypes: GuestType[];
  onClose: () => void;
  open: boolean;
}

export const OtherParticipantsModal = ({ guestTypes, onClose, open }: Props) => {
  const divRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const handleOutsideClick = ({ target }: Event) => {
      if (target instanceof Node && !divRef?.current?.contains(target)) {
        onClose();
      }
    };

    window.document.addEventListener('mousedown', handleOutsideClick, {
      capture: true,
    });
    window.document.addEventListener('touchstart', handleOutsideClick, {
      capture: true,
    });
    return () => {
      window.document.removeEventListener('mousedown', handleOutsideClick, {
        capture: true,
      });
      window.document.removeEventListener('touchstart', handleOutsideClick, {
        capture: true,
      });
    };
  }, [open]);

  return (
    <div style={{ display: open ? 'block' : 'none' }}>
      <div className="widget-calendar__number__overlay"></div>
      <div ref={divRef} className="widget-calendar__number__select">
        <GuestTypeList guestTypes={guestTypes} />
      </div>
    </div>
  );
};
